import api from './api';

export const profileService = {
  getProfiles: async (params = {}) => {
    const response = await api.get('/profiles', { params });
    return response.data;
  },

  getProfileById: async (id) => {
    const response = await api.get(`/profiles/${id}`);
    return response.data;
  },

  createProfile: async (data) => {
    const response = await api.post('/profiles', data);
    return response.data;
  },

  updateProfile: async (id, data) => {
    const response = await api.put(`/profiles/${id}`, data);
    return response.data;
  },

  updateProfileStatus: async (id, isActive) => {
    const response = await api.patch(`/profiles/${id}/status`, { isActive });
    return response.data;
  },

  getProfileComponents: async (id) => {
    const response = await api.get(`/profiles/${id}/components`);
    return response.data;
  },

  addProfileComponent: async (id, componentData) => {
    const response = await api.post(`/profiles/${id}/components`, componentData);
    return response.data;
  },

  removeProfileComponent: async (componentId) => {
    const response = await api.delete(`/profiles/components/${componentId}`);
    return response.data;
  },

  setProfileComponents: async (id, investigationIds) => {
    const response = await api.put(`/profiles/${id}/components/bulk`, { investigationIds });
    return response.data;
  }
};

export default profileService;
